import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.deleteRunner'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: _vm.color,
        emit: 'delete'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": _vm.deleteItem
    }
  }), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.cancelConfirmTitleCsvImport'),
      "open": _vm.cancelPromptCsvImport,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.cancel'),
        color: _vm.color,
        emit: 'cancelRunner'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.cancelPromptCsvImport = false;
      },
      "cancelRunner": _vm.cancelRunner
    }
  }), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.cancelConfirmTitleBulkEdit'),
      "open": _vm.cancelPromptBulkEdit,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.cancel'),
        color: _vm.color,
        emit: 'cancelRunner'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.cancelPromptBulkEdit = false;
      },
      "cancelRunner": _vm.cancelRunner
    }
  }), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.cancelConfirmTitleCsvExport'),
      "open": _vm.cancelPromptCsvExport,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.cancel'),
        color: _vm.color,
        emit: 'cancelRunner'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.cancelPromptCsvExport = false;
      },
      "cancelRunner": _vm.cancelRunner
    }
  }), _c(VRow, {
    class: _vm.containerClass,
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.isEmptyList ? [_c('core-n20Card', [_c('core-empty-state', {
    attrs: {
      "icon": "fa-sensor-on",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n              " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.noBulkExportJobs')) + "\n            ")];
      },
      proxy: true
    }], null, false, 2466144529)
  })], 1)] : [_c(VDataTable, {
    attrs: {
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooterProps,
      "single-select": false,
      "item-key": "id",
      "page": _vm.tableOptions.page,
      "data-cy": "vd_dt_export_table",
      "data-cy-is-loading": _vm.isFetching ? 'true' : 'false'
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item.title",
      fn: function ({
        item
      }) {
        return [_c('p', {
          staticClass: "title-cell ma-0 text-truncate",
          attrs: {
            "title": item.title
          }
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])];
      }
    }, {
      key: "item.state",
      fn: function ({
        item
      }) {
        return [_c('span', {
          class: {
            'red--text': item.tasks.errors > 0 || !!_vm.jobFailureReason(item),
            'green--text': item.tasks.errors === 0 && !_vm.jobFailureReason(item)
          },
          attrs: {
            "data-cy": `job_state_${item.id}`
          }
        }, [_vm._v("\n              " + _vm._s(_vm.getJobStatus(item)) + "\n            ")])];
      }
    }, {
      key: "item.type",
      fn: function ({
        item
      }) {
        return [_c('span', [_vm._v("\n              " + _vm._s(_vm.getResourceType(item)) + "\n            ")])];
      }
    }, {
      key: "item.createdAt",
      fn: function ({
        item
      }) {
        return [_c('span', [_vm._v("\n              " + _vm._s(_vm.localizeDate(item.createdAt)) + "\n            ")])];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c(VTooltip, {
          attrs: {
            "bottom": "",
            "disabled": !_vm.jobDownloadHint(item)
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [_c('div', _vm._g({}, on), [_c(VIcon, {
                staticClass: "mr-2",
                attrs: {
                  "disabled": !!_vm.jobDownloadHint(item),
                  "color": _vm.color,
                  "title": "",
                  "small": "",
                  "data-cy": `download_btn_${item.id}`
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return _vm.downloadFile(item);
                  }
                }
              }, [_vm._v("\n                    fal fa-download\n                  ")])], 1)];
            }
          }], null, true)
        }, [_c('span', {
          attrs: {
            "data-cy": `download_hint_${item.id}`
          }
        }, [_vm._v(_vm._s(_vm.jobDownloadHint(item)))])]), _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color,
            "title": "",
            "small": "",
            "data-cy": `info_btn_${item.id}`
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.$emit('show-item-info', item);
            }
          }
        }, [_vm._v("\n              fal fa-eye\n            ")]), _vm.canDeleteItem ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": item.state === 'in progress' ? _vm.$i18n_t('Common.cancel') : _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              item.state === 'in progress' ? _vm.showCancelPrompt(item) : _vm.showDeletePrompt(item);
            }
          }
        }, [_vm._v("\n              " + _vm._s(item.state === 'in progress' ? 'fal fa-times-circle' : 'fal fa-trash-alt') + "\n            ")]) : _vm._e()];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n            " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + "\n            " + _vm._s(items.itemsLength) + "\n          ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })]], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };